import { FaWhatsapp } from "react-icons/fa";
import { waLink } from "@/lib/constants";

export default function FloatingWhatsApp() {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Chat via WhatsApp"
      className="wa-pulse fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-whatsapp px-4 py-3 text-white shadow-[0_8px_30px_rgb(0,0,0,0.5)] transition-transform duration-300 hover:scale-105 hover:bg-whatsapp-dark sm:px-5"
    >
      <FaWhatsapp className="h-6 w-6" />
      <span className="hidden text-sm font-semibold sm:inline">Chat Sekarang</span>
    </a>
  );
}
